module.exports = __webpack_public_path__ + "media/customizations/brighton/logo-86ec9325f51a2eff9f83713c07c596e0.png";